import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getNspStatisticsProductsWithStatus } from '../../store/reducers';
import { GetNspStatisticsProducts } from '../store/actions/nsp.actions';
import { MessageBoxTypesEnum } from '@proximus/pxs-angular-design-system';

@Component({
  selector: 'mprd-nsp-statistics-banner',
  templateUrl: './nsp-statistics-banner.component.html',
})
export class NspStatisticsBannerComponent implements OnInit {
  protected readonly MessageBoxTypesEnum = MessageBoxTypesEnum;

  statisticsProductsWithStatus$ = this.store.select(
    getNspStatisticsProductsWithStatus,
  );

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(new GetNspStatisticsProducts());
  }
}
